const INCLUDE_WHITESPACE = /[\s]/;

export const whiteSpaceValidation = (message: string) => ({
    message,
    test: (value: unknown) => !INCLUDE_WHITESPACE.test(<string>value),
});
